import { useState } from 'react';
import { useApp } from '../estado';
import { useRecurso } from '../ganchos';
import { api } from '../api';
import { formatarDataHora } from '../formatacao';
import { Aviso, Carregando, EstadoVazio, TituloPagina } from '../componentes/ui';

const ROTULOS_ACAO: Record<string, string> = {
  'sessao.entrar': 'Entrada no painel',
  'receita.salvar': 'Receita salva',
  'template.criar': 'Template criado',
  'template.atualizar': 'Template atualizado',
  'template.remover': 'Template removido',
  'disparo.planejar': 'Planejamento do dia',
  'disparo.simular': 'Simulação de envio',
  'disparo.reprocessar': 'Disparo reprocessado',
  'disparo.cancelar': 'Disparo cancelado',
  'evento.importar': 'Importação de eventos',
  'optout.adicionar': 'Opt-out incluído',
  'optout.remover': 'Opt-out removido',
  'provedor.atualizar': 'Provedor atualizado',
  'canal.criar': 'Canal criado',
  'canal.atualizar': 'Canal atualizado',
  'canal.testar': 'Teste de canal',
  'elo.atualizar': 'Conexão com o ERP atualizada',
  'elo.testar': 'Teste de conexão com o ERP',
};

export function Auditoria() {
  const { provedor } = useApp();
  const auditoria = useRecurso(() => api.auditoria(), []);
  const [aberto, setAberto] = useState<string | null>(null);
  const fuso = provedor?.fuso ?? 'America/Sao_Paulo';

  const eventos = auditoria.dados?.eventos ?? [];

  return (
    <>
      <TituloPagina
        titulo="Auditoria"
        descricao="Quem fez o quê, quando. Cada alteração de régua, template, canal ou importação fica registrada com o e-mail do Atendente."
      />

      <Aviso tipo="info" titulo="Registro imutável por Provedor">
        A auditoria é escopada pelo <span className="mono">tenant_id</span>. Nenhum evento de outro
        Provedor aparece aqui, e o histórico não é apagado ao desligar uma receita.
      </Aviso>

      {auditoria.carregando && !auditoria.dados ? (
        <Carregando texto="Lendo o histórico…" />
      ) : auditoria.erro && !auditoria.dados ? (
        <Aviso tipo="erro" titulo="Não foi possível ler a auditoria">
          {auditoria.erro}
        </Aviso>
      ) : eventos.length === 0 ? (
        <EstadoVazio
          titulo="Nenhum evento registrado"
          texto="Assim que alguém entrar no painel ou salvar uma configuração, o registro aparece aqui."
          icone="◷"
        />
      ) : (
        <div className="tabela-rolagem">
          <table>
            <caption>Últimos 60 eventos deste Provedor.</caption>
            <thead>
              <tr>
                <th scope="col">Quando</th>
                <th scope="col">Ator</th>
                <th scope="col">Ação</th>
                <th scope="col">Detalhe</th>
              </tr>
            </thead>
            <tbody>
              {eventos.map((evento) => {
                const expandido = aberto === evento.id;
                const detalhe = JSON.stringify(evento.detalhe, null, 2);
                return (
                  <tr key={evento.id}>
                    <td className="numero">{formatarDataHora(evento.criadoEm, fuso)}</td>
                    <td>{evento.ator}</td>
                    <td>
                      <strong>{ROTULOS_ACAO[evento.acao] ?? evento.acao}</strong>
                      <br />
                      <span className="texto-pequeno mono">{evento.acao}</span>
                    </td>
                    <td>
                      {detalhe === '{}' ? (
                        <span className="texto-pequeno">—</span>
                      ) : (
                        <button
                          type="button"
                          className="botao botao--secundario botao--pequeno"
                          aria-expanded={expandido}
                          onClick={() => setAberto(expandido ? null : evento.id)}
                        >
                          {expandido ? 'Ocultar' : 'Ver detalhe'}
                        </button>
                      )}
                      {expandido ? (
                        <pre
                          className="detalhe mono"
                          style={{ marginTop: '0.5rem', whiteSpace: 'pre-wrap' }}
                        >
                          {detalhe}
                        </pre>
                      ) : null}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
}
